// The stopwatch of the stage, as the phones and the panel keep it: it starts at zero and
// counts up until the panel pauses it or resets it. Nothing to do with the scoreboard

export const EMPTY_STOPWATCH = { running: false, elapsedMs: 0, startedAt: null, version: 0 };

// Every change reaches the room as an `app:STOPWATCH` event with the whole stopwatch, as text
export const stopwatchFromEvent = ({ attributes }) => ({
  running: attributes.running === '1',
  elapsedMs: Number(attributes.elapsedMs) || 0,
  version: Number(attributes.version) || 0,
});

/**
 * The stopwatch after hearing `incoming` (from the room, /history or the panel API). Every
 * change bumps the version, so the same one again, or an older one that arrives late, never
 * wins. It comes as the time elapsed: while it runs, the device counts from the moment it
 * hears about it, by its own clock, so a phone with the wrong time shows the same as the rest.
 */
export const withStopwatch = (current, incoming, now = Date.now()) => {
  if (!incoming || !(incoming.version > current.version)) return current;
  const elapsedMs = Math.max(0, Number(incoming.elapsedMs) || 0);
  return { running: Boolean(incoming.running), elapsedMs, startedAt: incoming.running ? now - elapsedMs : null, version: incoming.version };
};

// Whole seconds on the stopwatch right now: 59.9 s still reads 00:59
export const secondsElapsed = (stopwatch, now = Date.now()) =>
  Math.floor(Math.max(0, stopwatch?.running ? now - stopwatch.startedAt : stopwatch?.elapsedMs ?? 0) / 1000);

// 75 -> "01:15"; past 99 minutes the minutes take the digits they need ("100:00")
export const stopwatchClock = (seconds) => `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
